var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"color":"primary","small":"","text":""},on:{"click":_vm.generate}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-arrow-top-right-bold-outline")])],1)]}}])},[_c('span',[_vm._v("Generate")])])
}
var staticRenderFns = []

export { render, staticRenderFns }